import Translation from '../../../../translation/translation';

function Image(props) {
    if (!props.image) {
        return null;
    }

    return (
        <div className="fsf-station__detail">
           <h3 className="fsf-station__detail-headline">
               <Translation translationKey="fitting-station-finder-app-streetview" />
           </h3>
           <div className="fsf-station__detail-contents">
                <img alt="" src={props.image} className="fsf-station__streeview-image" />
            </div>
        </div>
    );
}

export default Image;
